import { render, staticRenderFns } from "./ResendApi.vue?vue&type=template&id=d098d848&"
import script from "./ResendApi.vue?vue&type=script&lang=js&"
export * from "./ResendApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports